import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function GoogleAdsTracker() {
  const location = useLocation();
  console.log("lcoatiion",location)

  useEffect(() => {
    if (!window.gtag) return;

    const eventName = location.state?.event?.name;

    const payload = {
      page_path: location.pathname + location.search,
    };

    if (eventName) {
      payload.page_title = eventName;
    }

    console.log("Tracking:", payload);

    window.gtag("config", "AW-16832352541", payload);

  }, [location]);

  return null;
}